import { baseUrl } from "../../../boot/index.js";
import axios from "axios";

export const userSignin = async (data) => {
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/user/app/v1/signin`, data, {
      responseType: "json",
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    console.log("reduex api ", response);
    return response.data;
  } catch (error) {
    console.error("Error logging in user:", error);
    throw error;
  }
};
export const userSignup = async (data) => {
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/user/app/v1/signup-user`, data, {
      responseType: "json",
    });
    console.log("reduex api ", response);
    return response.data;
  } catch (error) {
    console.error("Error logging in user:", error);
    throw error;
  }
};

export const sendOtp = async (data) => {
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/user/app/v1/send-otp`, data, {
      responseType: "json",
    });
    console.log("send otp ", response);
    return response.data;
  } catch (error) {
    console.log("error logging in user", error);
    throw error;
  }
};

export const forgetPassword = async (data) => {
  try {
    const usrePass = await axios.post(`${baseUrl}cleaningappfunctions/user/app/v1/send-otp`, data, {
      responseType: "json",
    });
    console.log("reduex api ", usrePass);
    return usrePass.data;
  } catch (error) {
    console.error("Error logging in user:", error);
    throw error;
  }
};
export const verifyPassword = async (data) => {
  try {
    const usrePass = await axios.post(`${baseUrl}cleaningappfunctions/user/app/v1/verify-otp`, data, {
      responseType: "json",
    });
    // console.log("reduex api ", usrePass);
    return usrePass.data;
  } catch (error) {
    console.error("Error verify otp:", error);
    throw error;
  }
};
export const changePassword = async (data) => {
  try {
    const usrePass = await axios.post(`${baseUrl}cleaningappfunctions/user/app/v1/change-password`, data, {
      responseType: "json",
    });
    // console.log("reduex api ", usrePass);
    return usrePass.data;
  } catch (error) {
    console.error("Error verify otp:", error);
    throw error;
  }
};

export const refreshToken = async (data) => {
  try {
    // console.log("refresh token called");
    const usrePass = await axios.get(`${baseUrl}cleaningappfunctions/user/app/v1/refresh-token`, {
      withCredentials: true,
      responseType: "json",
    });
    return usrePass.data;
  } catch (error) {
    console.error("Error  otp:", error);
    throw error;
  }
};

// auth token
export const authTokenVerify = async (data) => {
  try {
    // console.log("auth token verify called");
    const response = await axios.get(`${baseUrl}cleaningappfunctions/user/app/v1/verify-token`, {
      withCredentials: true,
      responseType: "json",
      headers: {
        "Content-Type": "application/json",
      },
    });
    // console.log("phla chla", response);
    return response.data;
  } catch (error) {
    console.error("Error ogging in user:", error);
    throw error;
  }
};

// logout user
export const userLogout = async (data) => {
  try {
    // console.log("logout called");
    const response = await axios.get(`${baseUrl}cleaningappfunctions/user/app/v1/signout`, {
      withCredentials: true,
      responseType: "json",
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("logout response", response);
    return response.data;
  } catch (error) {
    console.error("Error logging out user:", error);
    throw error;
  }
};
